<div *ngIf="!!selectedRow" fxFlexFill>
  <div class="detailsPanelBody" *ngIf="!!dataDetail">
    <form class="example-form" #updateForm="ngForm">

      <!--  ************************************  -->
      <!--            USER FIRSTNAME              -->
      <!--  ************************************  -->
      <mat-form-field class="fullWidthField formFieldMargin">
        <mat-label>{{'USER.FIRSTNAME' | translate}}</mat-label>
        <input matInput required #userFirstname="ngModel" type="text" name="userFirstname" [disabled]="!editMode" [(ngModel)]="dataDetail.firstname">
        <mat-error *ngIf="userFirstname.invalid">
          {{'USER.FIRSTNAME_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
        </mat-error>
      </mat-form-field>

      <!--  ************************************  -->
      <!--             USER LASTNAME              -->
      <!--  ************************************  -->
      <mat-form-field class="fullWidthField formFieldMargin">
        <mat-label>{{'USER.LASTNAME' | translate}}</mat-label>
        <input matInput required #userLastname="ngModel" type="text" name="userLastname" [disabled]="!editMode" [(ngModel)]="dataDetail.lastname">
        <mat-error *ngIf="userLastname.invalid">
          {{'USER.LASTNAME_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
        </mat-error>
      </mat-form-field>


      <!--  ************************************  -->
      <!--              USER EMAIL                -->
      <!--  ************************************  -->
      <mat-form-field class="fullWidthField formFieldMargin">
        <mat-label>{{'USER.EMAIL' | translate}}</mat-label>
        <input matInput required #userEmail="ngModel" type="email" [pattern]="gmService.EMAIL_PATTERN_VALIDATOR" name="userEmail"
               [disabled]="!editMode" [(ngModel)]="dataDetail.email">
        <mat-error *ngIf="userEmail.hasError('required')">
          {{'USER.EMAIL_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
        </mat-error>
        <mat-error *ngIf="userEmail.dirty && dataDetail.email !== '' && userEmail.invalid">
          {{'USER.EMAIL_FIELD' | translate }} <strong>{{'COMMON.IS_IN_WRONG_FORMAT' | translate }}</strong>
        </mat-error>
      </mat-form-field>
    </form>
  </div>

</div>
